module.exports = __webpack_public_path__ + "static/media/phosphorus.aee265c1.png";